import { PayrollStatusEnum } from 'features/Enterprise/Payroll/types'
import type { PayrollStatusPillThemeType } from './employmentStatus'

export type PayrollStatusBadgeVariantType = 'blue' | 'orange' | 'green'

const PAYROLL_STATUS_BADGE_TO_PILL_THEME: Record<
  PayrollStatusBadgeVariantType,
  PayrollStatusPillThemeType
> = {
  blue: 'info',
  orange: 'warning',
  green: 'success',
}

const PAYROLL_STATUS_BADGE_COLOR_MAP: Record<PayrollStatusEnum, PayrollStatusBadgeVariantType> = {
  [PayrollStatusEnum.WAITING_OPS_HR_SUBMISSION]: 'orange',
  [PayrollStatusEnum.WAITING_OPS_SUBMISSION]: 'orange',
  [PayrollStatusEnum.WAITING_HR_SUBMISSION]: 'orange',
  [PayrollStatusEnum.WAITING_FOR_VALIDATION]: 'orange',
  [PayrollStatusEnum.READY_TO_PUBLISH]: 'blue',
  [PayrollStatusEnum.PUBLISHED]: 'green',
}

const VALIDATE_ENABLED_STATUSES: PayrollStatusEnum[] = [PayrollStatusEnum.WAITING_FOR_VALIDATION]

const CHECKBOX_ENABLED_STATUSES: PayrollStatusEnum[] = [PayrollStatusEnum.READY_TO_PUBLISH]

export const PAYROLL_STATUS_LABEL_MAP: Record<string, string> = {
  [PayrollStatusEnum.WAITING_OPS_HR_SUBMISSION]: 'Waiting Ops & HR submission',
  [PayrollStatusEnum.WAITING_OPS_SUBMISSION]: 'Waiting Ops Submission',
  [PayrollStatusEnum.WAITING_HR_SUBMISSION]: 'Waiting HR Submission',
  [PayrollStatusEnum.WAITING_FOR_VALIDATION]: 'Waiting for Validation',
  [PayrollStatusEnum.READY_TO_PUBLISH]: 'Ready to Publish',
  [PayrollStatusEnum.PUBLISHED]: 'Published',
}

export const getPayrollStatusLabel = (payrollStatus: string): string =>
  PAYROLL_STATUS_LABEL_MAP[payrollStatus] ?? payrollStatus

export const PAYROLL_STATUS_TAB_OPTIONS = [
  { label: 'Semua', value: '' },
  { label: 'Published', value: PayrollStatusEnum.PUBLISHED },
  { label: 'Ready to Publish', value: PayrollStatusEnum.READY_TO_PUBLISH },
  { label: 'Waiting for Validation', value: PayrollStatusEnum.WAITING_FOR_VALIDATION },
  { label: 'Waiting Ops Submission', value: PayrollStatusEnum.WAITING_OPS_SUBMISSION },
  { label: 'Waiting HR Submission', value: PayrollStatusEnum.WAITING_HR_SUBMISSION },
  { label: 'Waiting Ops & HR submission', value: PayrollStatusEnum.WAITING_OPS_HR_SUBMISSION },
]

export const getPayrollStatusBadgeVariant = (
  payrollStatus: string,
): PayrollStatusBadgeVariantType =>
  PAYROLL_STATUS_BADGE_COLOR_MAP[payrollStatus as PayrollStatusEnum] ?? 'orange'

export const getPayrollStatusPillTheme = (payrollStatus: string): PayrollStatusPillThemeType =>
  PAYROLL_STATUS_BADGE_TO_PILL_THEME[getPayrollStatusBadgeVariant(payrollStatus)]

export const isValidateEnabledByPayrollStatus = (payrollStatus: string): boolean =>
  VALIDATE_ENABLED_STATUSES.includes(payrollStatus as PayrollStatusEnum)

export const isPublishAllowedByPayrollStatusTab = (publishStatusTab: string): boolean =>
  publishStatusTab === '' || publishStatusTab === PayrollStatusEnum.READY_TO_PUBLISH

export const isCheckboxDisabledByPayrollStatus = (payrollStatus: string): boolean =>
  !CHECKBOX_ENABLED_STATUSES.includes(payrollStatus as PayrollStatusEnum)
